/**
 * USDA ERS Urban Influence Codes — county-level lookup.
 * Generated by data_raw/build_uic.R from the ERS UIC 2024 file.
 *
 * Value: integer 1–9 (2024 nine-category scheme). NOTE: the codes are NOT a
 * ranked rural gradient — they index settlement structure (metro/micro/noncore
 * status, metro adjacency, largest town size), not ordered remoteness.
 *
 * Source: https://www.ers.usda.gov/data-products/urban-influence-codes
 */

let _data = null;
let _loadPromise = null;

export function loadUicData() {
  if (_data) return Promise.resolve();
  if (_loadPromise) return _loadPromise;
  _loadPromise = fetch(`${process.env.PUBLIC_URL}/data/uic.json`)
    .then(r => {
      if (!r.ok) throw new Error(`Failed to load UIC data (${r.status})`);
      return r.json();
    })
    .then(d => { _data = d; _loadPromise = null; })
    .catch(err => { _loadPromise = null; throw err; });
  return _loadPromise;
}

export function getUICForCounty(stateFips, countyFips) {
  if (!_data) return null;
  const key = `${String(stateFips).padStart(2, "0")}${String(countyFips).padStart(3, "0")}`;
  const v = _data[key];
  return typeof v === "number" ? v : null;
}

// Short labels for the 2024 nine-category scheme (full ERS text condensed).
const UIC_LABELS = {
  1: "Large metro",
  2: "Micropolitan (adj. large metro)",
  3: "Noncore (adj. large metro)",
  4: "Small metro",
  5: "Micropolitan (adj. small metro)",
  6: "Noncore (adj. small metro)",
  7: "Micropolitan (nonadjacent)",
  8: "Noncore (nonadjacent, town ≥5k)",
  9: "Noncore (nonadjacent, no town ≥5k)",
};

export function getUICDescription(code) {
  if (code == null) return null;
  return UIC_LABELS[code] ?? null;
}

const uic = { loadUicData, getUICForCounty, getUICDescription };
export default uic;
